import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { IdealsOneApiService } from '../services/ideals-one-api.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Alert } from 'selenium-webdriver';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { Title } from '@angular/platform-browser';
import { timeout } from 'q';
import { concat, timer } from 'rxjs';
import { configMsg } from '../shared/constant-messages';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../app.component';
import * as moment from 'moment';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})

export class PurchaseComponent implements OnInit {
  ss
  suggestionModalReference: NgbModalRef;
  instructModalReference: NgbModalRef;
  maxSelectModalReference: NgbModalRef;

  public getResponseData: any;
  ticketData: any;
  ticketsItemData: any;
  pageInformations: any;
  siteInformations: any;
  removeOrders: any;
  orderStatus: any = [];
  addTocartStatus: any = [];
  loader: boolean;
  addToCartloader: boolean;
  addedItemsStatus: any;
  addTocartError: string;
  public pageInformationPassReq: any;
  invalidPassword: string;
  pagecontrolsData: any;
  navigationData: any;
  headerData: any;
  pageInfoSetTimeout: any;
  breadcrumbCaptions: any;
  hamburgerStatus: boolean;
  quantityList: any = [];
  quantityForm: FormGroup;
  selectFormName: any;
  cartItemsCount: any;
  removeItemNo: any;
  cardItemName: any;
  primary_symbol: any;

  qntSelectFormName: any;
  isValidPageId: boolean;
  closeResult: any = '';
  customPageData: any;
  pageQty: any;
  itemId: any;
  manualLocation: any;
  sugAvailable: any;
  sugIncluded: any;
  caption: any;
  price: any;
  image: any;
  itemNumber: any;
  orderQty: any;
  popQty: any;
  showSuggestionMod: any;
  modifier: any;
  modifiergroups: any;
  enableNext: any;
  modifierGroup: any;
  modifierCaption: any;
  allowMultiple: any;
  max: any;
  min: any;
  index: any;
  modQty: any;
  modGroupCounter: any;
  prevButtonDisabled: any;
  hideModGrp: any;
  suggetionContent: any;
  instructContent: any;
  nextButtonDisabled: any;
  modgroupQtyItems: any;
  noSuggestedModifiersExist: any;
  addSpecialInstructions: any;
  deliveryLocation: any;
  addItemNumber: any;
  addQuantity: any;
  modgroupItemQtyTotal: any;
  modgroupItemQtyTracker: any = [];
  availableGrp: any = [];
  modgroupItem: any = [];
  itemsId: any;
  itemQuantity: any;
  deliveryLocationID: any;
  instructionMsg: any;
  suggetionModalStatus: any;
  ver: any;
  maxSelectModifier: any;
  requires_reservation: any;
  weeklyCalendar: any = [];
  minDate: any;
  availableTimes: any;
  itemSold: any;
  isCalenderClick: boolean = false;
  isReserve: any = {};
  activeDay: any;
  activeCalendarDate: any;
  isFutureDate: boolean = false;
  futureClickDate: any;
  activePageId: any;
  calendarIcon: string = "&#128197;";
  shoppingTrolley: string = "&#128722;";
  menuDownArrow: string = "&#9660;";
  quantitySelect: any = 1;
  counter: number = 1;
  availability: any;
  selectItemNumber: any;
  pageidPassword: any = { pageId: '', password: '', reservation_date: '' };
  allQtySelection: any = [];
  fetchTicketData: any = [];
  selectedQty: any;
  ticketLocallySave: any = [];
  maxQuantityRes: number;
  callForOne: boolean = false;
  internal_menu: any;
  queryLocation: any;
  sessionLocationID: any;
  pageDeliveryLocation: any;
  deliveryLocationName: any;
  minMaxError: string;
  modGroupSecond: any;
  countTypeCharacter: number;
  nestedModifiers: any;
  nestedMods: any = [];
  modsIndex: any = 0;
  indexTo: any = -1;
  selectedModsQty: any = [];
  uniqueMods: any;
  ItemSum: number = 0;
  warningMessage: string = '';
  operatingSchedule: any;
  loginModalReference: NgbModalRef;
  customerModalReference: NgbModalRef;
  isVerificationScreen: boolean = false;
  customerData: any;
  emailAddress: any;
  phoneNumber: any;
  verificationCode: any;
  isEmailError: any;
  isPhoneError: any;
  isEmail: boolean = false;
  isPhone: boolean = false;
  customerInformation: any;
  isCodeError: any = '';
  customerName: string = 'Login';
  customerProfile: any = 'assets/img/user_profile.png';
  isDefault: boolean = true;
  allowSpecialInstructions: boolean;
  allowTips: boolean;
  glocalHeader: any = "";
  glocalFooter: any = "";
  footerElement: any;
  isCustomerLogin: boolean;
  isCartItems: boolean;
  customerScreen: boolean;
  customerDetails: any;
  customerContents: any;
  alertMessage: any;
  global_script_urls: any;
  global_script_code: any;
  global_css_urls: any;
  global_css_code: any;
  service_fee: any;
  customerType: any;
  alertloginMessage: any;
  selectedTime: any = [];
  selectedCapacityTime: any = [];
  timeSelection: any = "";
  itemofitemData: any = [];
  ticketinItems: any = [];
  selectedNestedItems: any;
  showDateWidth: number = window.innerWidth;
  screenWidth: number = window.innerWidth;
  captionText = [];
  ifFirst = false
  setIndex: number;
  items: any = [];
  itemsofitemsNumber: any = [];
  quantitydata: any = [];
  tempItemNumber: any = [];
  addModifierNumber: any = [];
  suggestedmodifierdata: any;
  parentmodifierData: any = [];
  compareRadioItemNumber: any = [];
  uniqIdRadio: any = [];
  checkRequiresReservation: any = [];
  checkRequiresReservationItem: boolean = true;
  checkItemNumberForLength: any = [];
  checkArrayElementCount: any = [];
  isReserves: any = {};
  JSON: any;




  constructor(private idealsOneApiService: IdealsOneApiService, private router: Router, private activatedRoute: ActivatedRoute,
    private titleService: Title, private renderer: Renderer2, private formBuilder: FormBuilder, private modalService: NgbModal,
    private cookieService: CookieService, private el: ElementRef, private sanitizer: DomSanitizer) {
    this.loader = true;
    this.addToCartloader = false;
    this.invalidPassword = '';
    this.instructionMsg = '';
    this.hamburgerStatus = false;
    this.isValidPageId = false;
    this.showSuggestionMod = true;
    this.hideModGrp = false;
    this.modgroupItemQtyTotal = 0;
    this.getQuantityList();
    this.ver = environment.VERSION;
    this.orderQty = 1;
    this.requires_reservation = false;
    this.ticketLocallySave = sessionStorage.cartimagecache ? JSON.parse(sessionStorage.cartimagecache) : [];
    this.countTypeCharacter = 0;
    this.isCustomerLogin = false;
    this.customerScreen = true;
    this.isCartItems = false;
    this.customerDetails = { name: '', email: '' }
    this.JSON = JSON;

    this.router.routeReuseStrategy.shouldReuseRoute = function (e) {
      return false;
    };
  }

  ngOnInit() {

    this.checkSiteInfo();
    let customerInfo = sessionStorage.customerInfo ? JSON.parse(sessionStorage.customerInfo) : null;
    if (customerInfo) {
      this.customerName = customerInfo.name || customerInfo.last_name ? `${customerInfo.first_name} ${customerInfo.last_name}` : 'Login';
      this.customerProfile = customerInfo.image ? this.customerProfileUrl(customerInfo.image) : 'assets/img/user_profile.png';
      this.isCustomerLogin = true;
    }

    // Access footer ID
    this.footerElement = document.getElementById('purchaseFooterID') as HTMLElement;
  }

  setDocTitle(title: string) {
    this.titleService.setTitle(title);
  }

  capacity_type(ticket: any) {
    if (ticket.availability != undefined) {
      if (ticket.availability.times.length > 0) {
        return ticket.availability.times[0].type
      } else {
        return 'item';
      }
    }

  }

  getPageId(calPost = false) {

    let pageId = '';
    this.activatedRoute.queryParams.subscribe(params => {
      if ((params.page !== this.activePageId) || (calPost)) {
        pageId = params.page;
      }

      this.queryLocation = params.delivery_location;
      if (this.queryLocation) {
        sessionStorage.delivery_location = this.queryLocation;
      }
      if (params.RoutingOverride != undefined && params.RoutingOverride != "") {
        sessionStorage.routing_override = JSON.stringify(params.RoutingOverride);
      }
    });

    if (pageId) {
      this.pageidPassword.pageId = pageId;
      this.pageidPassword.password = '';
      this.activePageId = pageId;
      this.checkRequiresReservation = [];
      this.checkItemNumberForLength = [];
      this.pageInfoSetTimeout = () => {
        this.sessionLocationID = sessionStorage.delivery_location ? sessionStorage.delivery_location : 'Pickup';
        const pageInformationObservable = this.idealsOneApiService.pageInformationReq(this.pageidPassword);
        pageInformationObservable.subscribe((pageInformationData: any) => {
          this.pageInformations = pageInformationData;

          if (this.pageInformations === undefined) {
            setTimeout(this.pageInfoSetTimeout, 1000);
          }
          else {

            if (this.pageInformations.data.message === 'page_information') {

              // filter delivery location from Array of delivery location.
              this.pageDeliveryLocation = this.pageInformations.data.delivery_locations ? this.pageInformations.data.delivery_locations : [];
              let isDelivery = '';
              this.pageDeliveryLocation.forEach((element) => {
                if (element.id === this.sessionLocationID)
                  isDelivery = element;
              });
              this.deliveryLocationName = isDelivery != '' ? isDelivery : 'Pickup';

              if (this.pageInformations.data.captions) {
                this.breadcrumbCaptions = this.pageInformations.data.captions;
                sessionStorage['breadcrumbInfo'] = JSON.stringify(this.breadcrumbCaptions);
              }

              if (this.pageInformations.data.body.items) {

                this.allowSpecialInstructions = this.pageInformations.data.allow_special_instructions;
                this.allowTips = this.pageInformations.data.allow_tips;
                this.internal_menu = this.pageInformations.data.internal_menu;

                this.requires_reservation = false;
                let pageInfoItems = this.pageInformations.data.body.items;

                for (let i = 0; i < pageInfoItems.length; i++) {
                  if (pageInfoItems[i].requires_reservation == true) {
                    this.requires_reservation = true;
                  }
                  let pageInfoItemsofItems = [];
                  if (pageInfoItems[i].items) {
                    for (let j in pageInfoItems[i].items) {
                      pageInfoItemsofItems.push(pageInfoItems[i].items[j])
                    }
                  }
                  if (pageInfoItemsofItems.length) {
                    this.requires_reservation = false;
                    for (let i = 0; i < pageInfoItemsofItems.length; i++) {
                      if (pageInfoItemsofItems[i].requires_reservation == true) {
                        this.requires_reservation = true;
                      }
                    }
                  }
                }

              }

              if (this.pageInformations.data.body.items != undefined) {
                let subitemsdata = [];
                this.pageInformations.data.body.items.forEach(element => {
                  if (element.requires_reservation == true) {
                    this.activeCalendarDate = element.availability.date.substring(0, 10);
                    this.activeCalendarDate = this.activeCalendarDate + "T00:00:00.000Z";
                  }
                  if (element.items) {
                    for (let i in element.items) {
                      subitemsdata.push(element.items[i])
                    }
                  }
                });
                if (subitemsdata.length) {
                  for (let i = 0; i < subitemsdata.length; i++) {
                    if (subitemsdata[i].requires_reservation == true) {
                      this.activeCalendarDate = subitemsdata[i].availability.date.substring(0, 10);
                      this.activeCalendarDate = this.activeCalendarDate + "T00:00:00.000Z";  //"T17:12:57.802Z";
                    }
                  }
                }

              }

              if (this.pageInformations.data.body.items != undefined) {

                this.pageInformations.data.body.items.forEach(element => {
                  if (element.requires_reservation == true) {
                    this.callForOne = false;
                  }
                });
              }
              sessionStorage['pageinformationData'] = JSON.stringify(this.pageInformations);
              sessionStorage.removeItem('selectedmodifiers');
              if (this.pageInformations.data.password_protected_page === true) {
                this.pageidPassword = {};
                this.invalidPassword = '';

                document.getElementById('openPasswordrequiredModel').click();
                this.pageInformationPassReq = (pass: any) => {
                  this.pageidPassword = { 'pageId': pageId, 'password': pass.password };
                  document.getElementById('closePasswordReqModel').click();

                  const pageInformationObservables = this.idealsOneApiService.pageInformationReq(this.pageidPassword);
                  pageInformationObservables.subscribe((pageInformationData1: any) => {
                    this.pageInformations = pageInformationData1;
                    if (this.pageInformations.data.password_protected_page) {
                      document.getElementById('openPasswordrequiredModel').click();
                      this.invalidPassword = 'Invalid password please try again';
                    } else {

                      sessionStorage['pageinformationData'] = JSON.stringify(this.pageInformations);
                      if (this.pageInformations.data.body.items) {
                        this.ticketData = this.pageInformations.data.body.items;

                        //checkRequiresReservation for items of items start
                        var tempRequiresReservation = this.pageInformations.data.body.items;
                        var indexCount = 0;
                        tempRequiresReservation.forEach((tempRequiresReservationItems) => {
                          if (tempRequiresReservationItems.items) {
                            var tempRequiresReservationItemsLengthTrue = 0;
                            var tempRequiresReservationItemsLengthFalse = 0;
                            var tempItemNumbers = []
                            if (tempRequiresReservationItems.items.length > 0) {

                              for (let nnn = 0; nnn < tempRequiresReservationItems.items.length; nnn++) {

                                if (tempRequiresReservationItems.items[nnn].requires_reservation == true) {
                                  if (tempRequiresReservationItems.items[nnn].availability.times.length > 0) {
                                    tempItemNumbers.push(tempRequiresReservationItems.items[nnn].item_number)
                                  }
                                  tempRequiresReservationItemsLengthTrue += 1;
                                } else {
                                  tempRequiresReservationItemsLengthFalse += 1;
                                }
                              }
                              this.checkItemNumberForLength.push(tempItemNumbers);
                              if (tempRequiresReservationItemsLengthFalse == tempRequiresReservationItems.items.length) {
                                this.checkRequiresReservation.push({ "position": indexCount, "count": tempRequiresReservationItemsLengthTrue });
                              } else {
                                this.checkRequiresReservation.push({ "position": indexCount, "count": tempRequiresReservationItemsLengthTrue });
                              }
                            }

                          } else {
                            this.checkRequiresReservation.push({ "position": indexCount, "count": 0 });
                          }
                          indexCount += 1;
                        })
                        //checkRequiresReservation for items of items end

                        this.customPageData = this.pageInformations.data;

                        // highlighted selected time for reservation items
                        if (this.selectedCapacityTime.length && this.requires_reservation) {

                          var filtered = this.selectedCapacityTime.filter(function (el) {
                            return el != "";
                          });

                          setTimeout(() => {
                            filtered.forEach((val) => {
                              let itemsSplit = val.split('=')[0];
                              let time = document.getElementById(itemsSplit)
                              time.style.background = '#08507d';
                              time.style.color = 'white';
                              document.getElementById('unable_' + val.split('_')[0]).style.display = 'block';
                              document.getElementById('disable_' + val.split('_')[0]).style.display = 'none';
                            })
                          }, 200);
                        }

                        // call checkShopStatus fun If operating schedule property available in the response
                        this.operatingSchedule = this.pageInformations.data.operating_schedule ? this.pageInformations.data.operating_schedule : {};
                        if (Object.keys(this.operatingSchedule).length > 0) { this.checkShopStatus(); }

                        // call get Date calendar fun only 1st time to rendering calendar dates
                        if (!this.callForOne) { this.getDateCalendar(); this.callForOne = true; }
                        // Here we are filtering availability times which is greater than zero
                        this.filterAvailability();

                        // start -- qnt on order page when page password procted 04-08-2020
                        const quantitySelectFormData = [];
                        const tktItmLength = this.ticketData.length;

                        for (let index = 0; index < tktItmLength; index++) {
                          if (this.ticketData[index].item_number !== undefined) {
                            this.qntSelectFormName = this.ticketData[index].item_number;
                            quantitySelectFormData.push({ [this.qntSelectFormName]: [''] });
                          }
                        }
                        const newQuantitySelectFormDataObj = Object.assign({}, ...quantitySelectFormData);
                        this.quantityForm = this.formBuilder.group(
                          newQuantitySelectFormDataObj
                        );

                        for (let item = 0; item < tktItmLength; item++) {
                          if (this.ticketData[item].item_number !== undefined) {
                            this.selectFormName = this.ticketData[item].item_number;
                            this.quantityForm.patchValue({ [this.selectFormName]: 1 });
                          }
                        }
                        // End
                      }

                      if (this.pageInformations.data.pagecontrols) {
                        this.pagecontrolsData = this.pageInformations.data.pagecontrols.items;
                      }

                      if (this.pageInformations.data.navigation.items) {
                        this.navigationData = this.pageInformations.data.navigation.items;

                        setTimeout(() => {
                          if (this.screenWidth < 780) {
                            this.manageNavigation()
                          }
                        }, 100);
                      }

                      if (this.pageInformations.data.header) {
                        this.headerData = this.pageInformations.data.header;
                      }

                      if (this.pageInformations.data.body.background_color) {
                        document.body.style.backgroundColor = this.pageInformations.data.body.background_color;
                      }

                      if (this.pageInformations.data.captions) {
                        this.breadcrumbCaptions = this.pageInformations.data.captions;
                        sessionStorage['breadcrumbInfo'] = JSON.stringify(this.breadcrumbCaptions);
                      }

                      this.loader = false;
                      this.checkOrderStatus();
                      console.log('Base Site:' + location.origin);

                      if (this.pageInformations.data.title) {
                        this.setDocTitle(this.pageInformations.data.title);
                      }

                      if (!this.pageInformations.data.navigation.items) {
                        this.renderer.addClass(document.body, 'no-nav');
                      }

                    }
                  });

                };
              } else {
                if (this.pageInformations.data.body) {
                  if (this.pageInformations.data.body.items) {
                    this.ticketData = this.pageInformations.data.body.items;

                    //checkRequiresReservation for items of items start
                    var tempRequiresReservation = this.pageInformations.data.body.items;
                    var indexCount = 0;
                    tempRequiresReservation.forEach((tempRequiresReservationItems) => {
                      if (tempRequiresReservationItems.items) {
                        var tempRequiresReservationItemsLengthTrue = 0;
                        var tempRequiresReservationItemsLengthFalse = 0;
                        var tempItemNumbers = []
                        if (tempRequiresReservationItems.items.length > 0) {

                          for (let nnn = 0; nnn < tempRequiresReservationItems.items.length; nnn++) {

                            if (tempRequiresReservationItems.items[nnn].requires_reservation == true) {
                              if (tempRequiresReservationItems.items[nnn].availability.times.length > 0) {
                                tempItemNumbers.push(tempRequiresReservationItems.items[nnn].item_number)
                              }
                              tempRequiresReservationItemsLengthTrue += 1;
                            } else {
                              tempRequiresReservationItemsLengthFalse += 1;
                            }
                          }
                          this.checkItemNumberForLength.push(tempItemNumbers);
                          if (tempRequiresReservationItemsLengthFalse == tempRequiresReservationItems.items.length) {
                            this.checkRequiresReservation.push({ "position": indexCount, "count": tempRequiresReservationItemsLengthTrue });
                          } else {
                            this.checkRequiresReservation.push({ "position": indexCount, "count": tempRequiresReservationItemsLengthTrue });
                          }
                        }

                      } else {
                        this.checkRequiresReservation.push({ "position": indexCount, "count": 0 });
                      }
                      indexCount += 1;
                    })
                    //checkRequiresReservation for items of items end

                    this.customPageData = this.pageInformations.data;

                    // call checkShopStatus fun If operating schedule property available in the response
                    this.operatingSchedule = this.pageInformations.data.operating_schedule ? this.pageInformations.data.operating_schedule : {};
                    if (Object.keys(this.operatingSchedule).length > 0) { this.checkShopStatus(); }

                    // call get Date calendar fun only 1st time to rendering calendar dates
                    if (!this.callForOne) { this.getDateCalendar(); this.callForOne = true; }
                    // Here we are filtering availability times which is greater than zero
                    this.filterAvailability();

                    // start -- qnt on order page 04-07-2020
                    const quantitySelectFormData = [];
                    const tktItmLength = this.ticketData.length;

                    for (let index = 0; index < tktItmLength; index++) {
                      if (this.ticketData[index].item_number !== undefined) {
                        this.qntSelectFormName = this.ticketData[index].item_number;
                        quantitySelectFormData.push({ [this.qntSelectFormName]: [''] });
                      }
                    }
                    const newQuantitySelectFormDataObj = Object.assign({}, ...quantitySelectFormData);
                    this.quantityForm = this.formBuilder.group(
                      newQuantitySelectFormDataObj
                    );

                    // We have set user selected quantity
                    for (let item = 0; item < tktItmLength; item++) {
                      if (this.ticketData[item].item_number !== undefined) {
                        this.selectFormName = this.ticketData[item].item_number;

                        if (this.allQtySelection.length > 0) {
                          this.allQtySelection.forEach(element => {
                            if (element.qtySelectionNo == this.selectFormName) {
                              this.quantityForm.patchValue({ [this.selectFormName]: element.quantity });
                            }
                          });
                        }
                        else {
                          this.quantityForm.patchValue({ [this.selectFormName]: 1 });
                        }
                      }
                    }
                    // End
                  }

                  if (this.pageInformations.data.pagecontrols) {
                    this.pagecontrolsData = this.pageInformations.data.pagecontrols.items;
                  }

                  if (this.pageInformations.data.navigation.items) {
                    this.navigationData = this.pageInformations.data.navigation.items;

                    const closeHamburger = () => {
                      this.hamburgerStatus = false;
                      this.renderer.removeClass(document.body, 'active-hemberg');
                    };
                    setTimeout(closeHamburger, 100);

                    setTimeout(() => {
                      if (this.screenWidth < 780) {
                        this.manageNavigation()
                      }
                    }, 100);

                  }

                  if (this.pageInformations.data.header) {
                    this.headerData = this.pageInformations.data.header;
                  }

                  if (this.pageInformations.data.body.background_color) {
                    document.body.style.backgroundColor = this.pageInformations.data.body.background_color;
                  }

                  this.loader = false;
                  this.checkOrderStatus();

                  if (this.pageInformations.data.title) {
                    this.setDocTitle(this.pageInformations.data.title);
                  }

                  if (!this.pageInformations.data.navigation.items) {
                    this.renderer.addClass(document.body, 'no-nav');
                  }

                } else {
                  if (this.pageInformations.data.page_error_message) {
                    this.isValidPageId = true;
                    setTimeout(this.invalidPageId, 300);
                  }
                }

              }

            }
          }

        });
      };
      const pageInfoReqTimer = setTimeout(this.pageInfoSetTimeout, 1000);
    } else {
      console.log('No page Id');
    }
  }

  // Here we are filtering items availability 
  filterAvailability = () => {

    let maxArr = [];
    if (this.requires_reservation) {

      this.ticketData.forEach((item, index, theArray) => {

        let updatedAvailability = [];
        if (item.availability) {
          for (let i = 0; i < item.availability.times.length; i++) {
            maxArr.push(item.availability.times[i].available_items);
            if (item.availability.times[i].available_items > 0) {
              updatedAvailability.push(item.availability.times[i]);
            }
          }
          theArray[index].availability.times = updatedAvailability;
        }

        // Get max availability for quantity selection.
        this.maxQuantityRes = maxArr.sort((a, b) => a - b)[maxArr.length - 1]
        this.quantityList = [];

        let maximumQuantity = this.maxQuantityRes ? this.maxQuantityRes : 10;

        for (let index = 0; index < maximumQuantity; index++) {
          this.quantityList.push(index);
        }

      })

    }
    else {

      this.updateQuantity();
    }
  }

  invalidPageId = () => {
    document.getElementById('openPageIdErrorModel').click();
  }

  hamburgerOpenClosed() {
    this.hamburgerStatus = !this.hamburgerStatus;
    if (this.hamburgerStatus === true) {
      this.renderer.addClass(document.body, 'active-hemberg');
      this.renderer.addClass(document.getElementById('tgl-container'), 'change');
    } else {
      this.renderer.removeClass(document.body, 'active-hemberg');
      this.renderer.removeClass(document.getElementById('tgl-container'), 'change');
    }
  }

  setCartItems(itemNo, caption) {
    this.removeItemNo = itemNo;
    this.cardItemName = caption;
  }

  removeCartItems() {

    let itemNo = this.removeItemNo;
    let cartItemDetails = this.orderStatus.data.items;

    for (let i = 0; i < cartItemDetails.length; i++) {
      if (cartItemDetails[i].item_number == itemNo) {

        let removeItemId = cartItemDetails[i].id;
        const removeOrdersObservable = this.idealsOneApiService.removeItemFromOrderReq(removeItemId);
        removeOrdersObservable.subscribe((removeItemFromOrderReqData: any) => {
          this.removeOrders = removeItemFromOrderReqData;

          // Check Orders Status
          const orderStatusObservableResponse = this.idealsOneApiService.orderStatusReq();
          orderStatusObservableResponse.subscribe((orderStatusData: any) => {
            this.orderStatus = orderStatusData;
            sessionStorage['addedItemsTocart'] = "";
            sessionStorage['addedItemsTocart'] = JSON.stringify(this.orderStatus);
            if (this.orderStatus.data.items) {
              this.cartItemsCount = this.orderStatus.data.items.length;
            }
            else {
              this.cartItemsCount = undefined;
            }
          });
        });
      }
    }
    setTimeout(function () {
      document.getElementById("removeClose").click();
      document.getElementById(itemNo + 'qnt').className = 'btn-delete-cart-dsbl';
    }, 1000);
  }

  siteInformation() {
    const siteInfoSetTimeout = () => {

      const siteInformationObservable = this.idealsOneApiService.siteInformationReq();
      siteInformationObservable.subscribe((siteInformationData: any) => {
        this.siteInformations = siteInformationData;
        this.getPageId();

        if (this.siteInformations === undefined) {
          setTimeout(siteInfoSetTimeout, 500);
        } else {
          if (this.siteInformations.message === 'site_information') {
            sessionStorage['siteInfo'] = JSON.stringify(this.siteInformations);
            const backgroundStyle = this.siteInformations.data.background_style;
            document.body.style.backgroundImage = 'url(' + backgroundStyle + ')';
          }
        }
      });
    };
    const siteInfoReqTimer = setTimeout(siteInfoSetTimeout, 500);
  }

  checkSiteInfo() {
    const siteInfoSetTimeout = () => {
      if (sessionStorage['siteInformations']) {
        this.getPageId();
        this.siteInformations = JSON.parse(sessionStorage['siteInformations']);
        this.primary_symbol = this.siteInformations.data.currency.primary_symbol;
        const backgroundStyle = this.siteInformations.data.background_style;
        document.body.style.backgroundImage = 'url(' + backgroundStyle + ')';
        this.getGlobalScriptProperties();
        if (this.siteInformations.data.service_fee != undefined && this.siteInformations.data.service_fee.disclosure != undefined) {
          this.service_fee = this.siteInformations.data.service_fee.disclosure;
        }
      }
      else {
        setTimeout(siteInfoSetTimeout, 1000);
      }
    };
    const siteInfoReqTimer = setTimeout(siteInfoSetTimeout, 1000);
  }

  // Open suggedted modifier modal popup
  suggestedModifier(customerContents, suggetionContent, instructContent, maxSelectModifier, item, suggesationMod, quantity) {

    for (let i = 0; i < quantity; i++) {
      this.ticketLocallySave.push(item);
      sessionStorage.cartimagecache = JSON.stringify(this.ticketLocallySave);
    }

    this.suggestedmodifierdata = suggesationMod;
    this.isReserve.time = 'null';
    // assign selected time when adding item to cart for capacity
    this.selectedCapacityTime.forEach((element, index) => {
      let convtStrtotime = element.split('=')[1];
      if (element.split('_')[0] == item.item_number) {
        this.isReserve.time = convtStrtotime;
      }

    })
    this.customerContents = customerContents;
    this.isReserve.date = this.activeCalendarDate;


    // Start : Check if Item has suggestion modifier or Not
    this.suggetionContent = suggetionContent;
    this.instructContent = instructContent;
    this.maxSelectModifier = maxSelectModifier;
    this.itemsId = item.item_number;
    this.itemQuantity = quantity;
    var available = [];
    var included = [];
    this.pageQty = quantity;
    var pageInfo = this.customPageData;
    this.itemId = item;
    this.manualLocation = pageInfo.delivery_locations;
    this.orderQty = quantity;
    var deliveryLocation = "";
    var deliveryType = "";
    var addModifiers = [];
    var addSuggestedModifiers = [];

    // Start : Check Modifier group available
    var index = pageInfo.body.items.findIndex((x) => x.item_number === item.item_number);
    if (index > -1 && index < pageInfo.body.items.length) {
      this.modifier = pageInfo.body.items[index].modifier_groups;
      for (let i in this.modifier) {
        for (let j in this.modifier[i].modifiers) {
          this.modifier[i].modifiers[j]["parentItemNumber"] = item.item_number == '' ? '' : item.item_number;
          this.parentmodifierData.push(this.modifier[i].modifiers[j])

        }
      }

      // <----> We are getting nested mods items <---->
      this.nestedModifiers = item.items ? item.items : [];

      if (this.ifFirst == false) {
        this.captionText = item.caption

      }

      for (let i in this.nestedModifiers) {
        if (this.nestedModifiers[i].caption != '' || this.nestedModifiers[i].caption != undefined) {

          for (let j in this.nestedModifiers[i].modifier_groups) {
            if (this.nestedModifiers[i].modifier_groups.length) {
              this.nestedModifiers[i].modifier_groups[j]["insideCaption"] = this.nestedModifiers[i].caption == '' ? '' : this.nestedModifiers[i].caption;
              this.nestedModifiers[i].modifier_groups[j]["itemNumber"] = this.nestedModifiers[i].item_number == '' ? '' : this.nestedModifiers[i].item_number;
            }
            for (let k in this.nestedModifiers[i].modifier_groups[j].modifiers) {
              this.nestedModifiers[i].modifier_groups[j].modifiers[k]["parentItemNumber"] = this.nestedModifiers[i].item_number == '' ? '' : this.nestedModifiers[i].item_number;
            }
          }
        }
      }


      this.nestedModifiers.forEach((element) => {
        element.modifier_groups.forEach((modifierGroup) => {
          this.nestedMods.push(modifierGroup);
        });
      });

      this.modifiergroups = true;
      this.enableNext = true;
      if (pageInfo.body.items[index].modifier_groups.length > 0) {
        this.modifierGroup = this.modifier[0].modifiers;
        this.modifierCaption = this.modifier[0].caption;
        this.allowMultiple = this.modifier[0].allow_multiple;
        this.max = this.modifier[0].max;
        this.min = this.modifier[0].min;
        this.index = 0;
        this.modQty = 1;
      }
      // if top level modifier_groups is not availble then child level modifiers data will be promt.
      else if (this.nestedModifiers.length > 0 && pageInfo.body.items[index].modifier_groups.length == 0 && this.nestedMods.length > 0) {
        this.modifierGroup = this.nestedMods[this.modsIndex].modifiers;
        this.modifierCaption = this.nestedMods[this.modsIndex].caption;
        this.captionText = this.nestedMods[this.modsIndex].insideCaption;
        this.itemsofitemsNumber.push(this.nestedMods[this.modsIndex].itemNumber);
        this.max = this.nestedMods[this.modsIndex].max;
        this.min = this.nestedMods[this.modsIndex].min;
        this.allowMultiple = this.nestedMods[this.modsIndex].allow_multiple;
        this.indexTo = this.modsIndex;
        this.modsIndex++;
      }
    } else {
      this.modifiergroups = false;
      this.enableNext = false;
    }

    // End : Check Modifier group available
    if (suggesationMod.available.length > 0 || suggesationMod.included.length > 0) {
      for (var i = 0; i < suggesationMod.available.length; i++) {
        if (item.item_number == suggesationMod.available[i].item_number) {
          available.push(suggesationMod.available[i]);
        }
      }

      this.sugAvailable = available;
      for (var i = 0; i < suggesationMod.included.length; i++) {
        if (item.item_number == suggesationMod.included[i].item_number) {
          included.push(suggesationMod.included[i]);
        }
      }
      this.sugIncluded = included;
      this.caption = item.caption;
      this.price = item.price;
      this.image = item.image ? item.image : 'assets/img/default-tickets.png';
      this.itemNumber = item.item_number;
      this.openSuggestionModal(suggetionContent);

      if (included.length > 0 || available.length > 0) {
        var orderStatus = this.orderStatus.data;
        if (this.orderStatus.data.items != undefined) {
          for (var i = 0; i < orderStatus.items.length; i++) {
            if (item.item_number == orderStatus.items[i].item_number) {
              var tempQty = orderStatus.items[i].quantity;
              if (tempQty == undefined) {
                this.orderQty = parseInt(quantity);
              } else {
                this.orderQty = orderStatus.items[i].quantity;
              }
            } else {
              this.orderQty = parseInt(quantity);
            }
          }
        } else {
          this.orderQty = parseInt(quantity);
        }
      }
      else {
        this.noSuggestedModifiersExist = true;
        this.openModifierGroupPopup();
        this.showSuggestionMod = false;
        this.hideModGrp = true;
        if (item.modifier_groups != undefined && item.modifier_groups.length > 0) {

        }
        else {

          var includedMod = this.sugIncluded;
          if (quantity != null && item != null) {
            for (var i = 0; i < includedMod.length; i++) {
              addModifiers.push(includedMod[i].modifier_item_number);
            }
          }

          this.popQty = false;
        }
      }
    }
    else {
      var includedMod = this.sugIncluded;
      if (quantity != null && item != null) {
        for (var i = 0; i < includedMod.length; i++) {
          addModifiers.push(includedMod[i].modifier_item_number);
        }
        this.addToCart(parseInt(quantity), item.item_number, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, this.addSpecialInstructions, this.selectedNestedItems);
      }
    }
  }

  updateQuantity() {
    var modMaxQty = [];
    this.quantityList.forEach((element, index) => {
      modMaxQty.push(index);
    })
    setTimeout(() => { this.quantityList = modMaxQty; }, 200)
  }

  excludeModifier(itemNo, modifierNo) {

    var included = this.sugIncluded;
    var available = this.sugAvailable;
    for (var i = 0; i < included.length; i++) {
      if (modifierNo == included[i].modifier_item_number) {
        var price = included[i].price;
        this.price = this.price - price;
        available.push(included[i]);
        included.splice(i, 1);
        i--;
      }
    }
    this.sugIncluded = included;
    this.sugAvailable = available;
  };

  includeModifier(itemNo, modifierNo) {

    var included = this.sugIncluded;
    var available = this.sugAvailable;

    for (var i = 0; i < available.length; i++) {
      if (modifierNo == available[i].modifier_item_number) {
        var price = available[i].price;
        this.price = this.price + price;
        included.push(available[i]);
        available.splice(i, 1);
        i--;
      }
    };
    this.sugIncluded = included;
    this.sugAvailable = available;
  };

  openLoginModal(loginData) {
    this.customerScreen = true;
    this.isCodeError = '';
    this.loginModalReference = this.modalService.open(loginData, { backdrop: 'static' });
    this.loginModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openCustomerModal(customer) {
    this.customerModalReference = this.modalService.open(customer, { backdrop: 'static' });
    this.customerModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openSuggestionModal(suggetionContent) {
    this.suggetionModalStatus = true;
    this.suggestionModalReference = this.modalService.open(suggetionContent);
    this.suggestionModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.closeSuggestionPop();
    });
  }


  openInstructionModal(instructContent) {
    this.instructModalReference = this.modalService.open(instructContent);
    this.instructModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.closeInstructionPop();
    });
  }


  openAlertModal(maxSelectModifier) {
    this.maxSelectModalReference = this.modalService.open(maxSelectModifier);
    this.maxSelectModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closeSuggestionPop() {
    this.showSuggestionMod = true;
    this.suggestionModalReference.close();
    this.hideModGrp = false;
    this.enableNext = true;
    this.modifierGroup = null;
    this.modifierCaption = null;
    this.modifier = null;
    this.modgroupQtyItems = [];
    this.nextButtonDisabled = false;
    this.modgroupItemQtyTotal = 0;
    this.nestedMods = [];
    this.modgroupItemQtyTracker = [];
    this.modsIndex = 0;
    this.indexTo = -1;
    this.selectedModsQty = [];
    this.itemsofitemsNumber = [];
    this.addModifierNumber = [];
    sessionStorage.removeItem('selectedmodifiers');
    let elm = document.getElementById("modifierNextButton");
    this.modGroupSecond = "";
  }

  // Start : close special Instruction page
  closeInstructionPop() {
    this.countTypeCharacter = 0;
    this.instructionMsg = '';
    this.showSuggestionMod = true;
    this.instructModalReference.close();
    this.hideModGrp = false;
    this.enableNext = true;
    this.modifierGroup = null;
    this.modifierCaption = null;
    this.modifier = null;
    this.modgroupItem = [];
    this.modsIndex = 0;
    this.indexTo = -1;
    this.selectedModsQty = [];
    sessionStorage.removeItem('selectedmodifiers');
  }

  closeMaxSelectModifier() {
    this.maxSelectModalReference.close();
  }

  // Start : Functionlity to support modifier group
  openModifierGroupPopup() {

    this.modGroupCounter = 1;
    var modMaxQty = [];
    this.modQty = 0;
    // this.prevButtonDisabled = this.sugIncluded.length > 0 ? false : true;
    // this.updateQuantity();
    if (this.modifierGroup != undefined && this.modifierGroup.length > 0) {
      this.modifiergroups = false;
      this.showSuggestionMod = false;
      this.hideModGrp = true;
      this.enableNext = false;
    }
    else {
      this.closeSuggestionPop();

      // we are showing special instruction based on conditions.
      if (this.allowSpecialInstructions == undefined) {
        if (this.internal_menu && this.internal_menu != undefined) this.openInstructionModal(this.instructContent);
        else this.manualPlaceOrder(true);
      }
      else {
        if (this.allowSpecialInstructions) this.openInstructionModal(this.instructContent);
        else this.manualPlaceOrder(true);

      }

    }
  }

  addGrpModItem(itemNumber, parentItemN) {

    var uniqueItemofItems = `${itemNumber}_${parentItemN}`;
    var v = document.getElementById("i_" + uniqueItemofItems);
    var chkbox = document.getElementById("chk_" + uniqueItemofItems) as HTMLInputElement;
    var qtyDD = document.getElementById("qty_" + uniqueItemofItems) != null ? (document.getElementById("qty_" + uniqueItemofItems) as HTMLSelectElement).value : "";
    var qtyDDValString = qtyDD.replace("number:", "");
    var qtyDDVal = parseInt(qtyDDValString);
    var itemExists = false;

    if (this.modgroupItemQtyTracker.length > 0) {
      itemExists = false;
      for (i = 0; i < this.modgroupItemQtyTracker.length; i++) {
        if (this.modgroupItemQtyTracker[i].itemNumber == uniqueItemofItems) {
          this.modgroupItemQtyTracker[i].quantity = qtyDDVal;
          itemExists = true;
          break;
        }
      }
      if (!itemExists) {
        this.modgroupItemQtyTracker.push({ itemNumber: uniqueItemofItems, quantity: qtyDDVal ? qtyDDVal : 1 });
      } else {
        this.modgroupItemQtyTracker.forEach(item => {
          if (item.itemNumber == uniqueItemofItems) {
            let index = this.modgroupItemQtyTracker.findIndex(items => items.itemNumber == uniqueItemofItems);
            this.modgroupItemQtyTracker.splice(index, 1)
          }
        })

      }
      this.modgroupItemQtyTotal = 0;
      for (i = 0; i < this.modgroupItemQtyTracker.length; i++) {
        this.modgroupItemQtyTotal += this.modgroupItemQtyTracker[i].quantity;
      }
    }

    else {
      this.modgroupItemQtyTracker.push({ itemNumber: uniqueItemofItems, quantity: qtyDDVal ? qtyDDVal : 1 });
      this.modgroupItemQtyTotal = this.modgroupItemQtyTracker[0].quantity;
    }

    // set selected quantity on mods array
    this.modifierGroup.forEach((element) => {
      if (element.item_number === itemNumber) {
        element.qty_value = qtyDDVal;
      }
    });
    let isQunatity = qtyDD != "" ? qtyDD : 1;
    this.storeSelectItems(uniqueItemofItems, isQunatity);

    if (v.className == "" && chkbox == null) {

      if ((this.modgroupItemQtyTotal > this.max && this.max > 0) && qtyDD > "0") {
        this.openAlertModal(this.maxSelectModifier);
        this.minMaxError = `You can only add ${this.max} item(s)`;
        this.nextButtonDisabled = true;
      }
      else {
        this.nextButtonDisabled = false;
        this.modgroupQtyItems = [];
        let elm = document.getElementById("modifierNextButton");
        if (elm.classList.contains("dim-80")) {
          elm.classList.remove("dim-80");
        }
        var i = 0;
        for (i = 0; i < this.modgroupItemQtyTracker.length; i++) {
          var quant = this.modgroupItemQtyTracker[i]["quantity"];
          var itNum = this.modgroupItemQtyTracker[i].itemNumber;
          for (let j = 0; j < quant; j++) {
            this.modgroupQtyItems.push(itNum);
          }
        }
      }
    }
    else if (chkbox.checked) {
      chkbox['checked'] = true;
      if (this.modgroupItemQtyTotal > this.max && this.max > 0) {
        this.openAlertModal(this.maxSelectModifier);
        this.minMaxError = `You can only add ${this.max} item(s)`;
        chkbox.checked = false;
        this.modgroupItemQtyTracker.pop();
      }
      else {
        this.modgroupItem.push(uniqueItemofItems);
      }
    }
    else {
      if (chkbox.checked == false) chkbox['checked'] = false;
      v.className = "";
      const index = this.modgroupItem.indexOf(uniqueItemofItems);
      if (index > -1) {
        this.modgroupItem.splice(index, 1);
      }
    }
  }

  // Retain previous value of checkbox input element on suggested modifiers screen
  storeSelectItems(itemNumber, qtyDDVal) {

    if (qtyDDVal > 0 || qtyDDVal == 'rd_01') {
      let modsItems = sessionStorage.getItem('selectedmodifiers') ? JSON.parse(sessionStorage.getItem('selectedmodifiers')) : [];
      if (modsItems.length > 0) {

        var isItemsPresent = modsItems.some(function (el) { return el.itemNumber == itemNumber });

        if (isItemsPresent) {
          modsItems.some(function (el) {
            if (el.itemNumber === itemNumber) {
              el.quantity = qtyDDVal;
            }
          });
          sessionStorage.setItem('selectedmodifiers', JSON.stringify(modsItems));
        } else {
          modsItems.push({ itemNumber: itemNumber, quantity: qtyDDVal });
          sessionStorage.setItem('selectedmodifiers', JSON.stringify(modsItems));
        }
      } else {
        sessionStorage.setItem('selectedmodifiers', JSON.stringify(this.modgroupItemQtyTracker));
        this.selectedModsQty = this.modgroupItemQtyTracker;
      }
    }
  }

  setPreviousMods() {

    try {
      let getmodifiers = sessionStorage.getItem('selectedmodifiers');
      let modsItems = getmodifiers ? JSON.parse(getmodifiers) : [];
      let renderIds = [];

      this.modifierGroup.forEach((item) => {
        let uniqueId = `${item.item_number}_${item.parentItemNumber}`
        renderIds.push(uniqueId);
      })

      this.modgroupItem.forEach((element) => {
        if ((document.getElementById("chk_" + element) as HTMLInputElement) != null)
          (document.getElementById("chk_" + element) as HTMLInputElement).checked = true;
      })

      modsItems.forEach((item) => {
        if (renderIds.includes(item.itemNumber)) {
          if (item.quantity === 'rd_01') {
            (document.getElementById("rd_" + item.itemNumber) as HTMLInputElement).checked = item.quantity == "rd_01" ? true : false;
          } else {
            if (document.getElementById("qty_" + item.itemNumber) != null) {
              (document.getElementById("qty_" + item.itemNumber) as HTMLSelectElement).value = item.quantity;
            }
          }
        }
      })
    }
    catch (error) {
      console.log(error);
    }
  }

  // Start: Add special Instruction page
  instruction(check) {
    this.addSpecialInstructions = this.instructionMsg;
    this.instructionMsg = "";
    this.manualPlaceOrder(true);
    this.closeInstructionPop();
  }

  prevModifier(index) {

    if (this.indexTo > 0) {
      if (this.quantitydata.length) {
        this.quantitydata.pop();
        this.itemsofitemsNumber.pop();
        this.addModifierNumber.pop();
      }

    }
    try {

      if ((this.sugAvailable.length == 0 && this.sugIncluded.length == 0) && (this.modGroupCounter == 1 && this.noSuggestedModifiersExist)) {
        this.closeSuggestionPop();
      }
      else {
        this.modGroupCounter -= 1;
        this.modgroupQtyItems = [];
        this.nextButtonDisabled = false;
        this.modgroupItemQtyTotal = 0;
        this.modgroupItemQtyTracker = [];
        let modGrpRd = document.getElementsByName("modifiergrp");

        for (var i = 0; i < modGrpRd.length; i++) {
          modGrpRd[i]['checked'] = false;
        }

        let elm = document.getElementById("modifierNextButton");
        if (elm.classList.contains("dim-80")) {
          elm.classList.remove("dim-80");
        }

        if ((this.modGroupCounter == 1 && this.noSuggestedModifiersExist) && this.sugAvailable.length < 1) {
        }

        if (this.nestedModifiers.length > 0 && this.indexTo > 0) {

          if (this.indexTo >= 0) {
            this.modifierGroup = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].modifiers;
            this.modifierCaption = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].caption;
            this.captionText = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].insideCaption;
            this.max = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].max;
            this.min = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].min;
            this.allowMultiple = this.nestedMods[this.indexTo > 0 ? this.indexTo - 1 : 0].allow_multiple;
            this.modsIndex = this.modsIndex - 1;
            // this.modsIndex = this.modsIndex === 1 ? this.modsIndex - 1 : this.modsIndex;
            this.indexTo = this.indexTo - 1;
            setTimeout(() => { this.setPreviousMods(); }, 100)
          }
        }
        else {
          let i = this.indexTo > -1 ? index : index - 1;
          if (i > -1) {
            this.modifierGroup = this.modifier[i].modifiers;
            this.modifierCaption = this.modifier[i].caption;
            this.captionText = this.modifier[i].caption;
            this.max = this.modifier[i].max;
            this.min = this.modifier[i].min;
            this.index = this.indexTo > -1 ? index : index - 1;
            this.indexTo = this.indexTo - 1;
            this.allowMultiple = this.modifier[i].allow_multiple;
            setTimeout(() => { this.setPreviousMods(); }, 200)
            setTimeout(() => { this.assignSelectedMods(); }, 500)
          } else {
            this.modifiergroups = true;
            this.showSuggestionMod = true;
            this.hideModGrp = false;
            this.enableNext = true;
            if (this.modifier[i]) {
              this.allowMultiple = this.modifier[i].allow_multiple;
            }
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  nextModifier(index) {


    this.items = [];
    // send items of items data
    if (this.modsIndex > 0) {
      if (this.nestedModifiers != undefined) {
        this.nestedMods.forEach(data => {
          data.modifiers.forEach(modifierdata => {
            this.tempItemNumber.push(modifierdata.item_number);
          });
        });

        //Remove duplicate
        let uniqueChars;
        if (this.tempItemNumber.length > 0) {
          uniqueChars = this.tempItemNumber.filter((c, index) => {
            return this.tempItemNumber.indexOf(c) === index;
          });
        }

        if (this.modgroupItemQtyTracker.length) {
          let getmodifiers = sessionStorage.getItem('selectedmodifiers');
          let modsItems = getmodifiers ? JSON.parse(getmodifiers) : [];
          let modifierData = [];


          if (modsItems != undefined) {
            modsItems.forEach((item) => {

              if ((document.getElementById("qty_" + item.itemNumber) as HTMLSelectElement) != null) {

                let uniqueItemNumber = (document.getElementById("qty_" + item.itemNumber) as HTMLSelectElement)
                let particularId = uniqueItemNumber.id;
                if (item.itemNumber != '') {
                  let itemQuantity = item.quantity;
                  for (let i = 1; i <= itemQuantity; i++) {
                    modifierData.push(parseInt(particularId.split("_")[1]))
                  }

                }



              }
              if ((document.getElementById("chk_" + item.itemNumber) as HTMLInputElement) != null) {
                var selectedCheckboxs = (document.getElementById("chk_" + item.itemNumber) as HTMLInputElement);

                if (selectedCheckboxs != undefined) {
                  if (selectedCheckboxs.checked) {
                    var uniqueCheckItem = (document.getElementById("chk_" + item.itemNumber) as HTMLInputElement).id;

                    if (uniqueCheckItem != undefined) {
                      modifierData.push(parseInt(uniqueCheckItem.split("_")[1]))
                    }
                  }

                }
              }
            })

            this.addModifierNumber.push(modifierData);

          }

        }
        else {
          let getmodifiers = sessionStorage.getItem('selectedmodifiers');
          let modsItems = getmodifiers ? JSON.parse(getmodifiers) : [];
          let itemNumber = []
          if (modsItems != undefined) {
            modsItems.forEach((item) => {

              if (document.getElementById("qty_" + item.itemNumber) != null) {


                let uniqueItemNumber = (document.getElementById("qty_" + item.itemNumber) as HTMLSelectElement)
                let particularId = uniqueItemNumber.id;
                if (item.itemNumber != '') {
                  let itemQuantity = item.quantity;
                  for (let i = 1; i <= itemQuantity; i++) {
                    itemNumber.push(parseInt(particularId.split("_")[1]))
                  }

                }

              }

              if ((document.getElementById("chk_" + item.itemNumber) as HTMLInputElement) != null) {
                var uniqueCheckItem = (document.getElementById("chk_" + item.itemNumber) as HTMLInputElement).id;

                if (uniqueCheckItem != undefined) {
                  itemNumber.push(parseInt(uniqueCheckItem.split("_")[1]))
                }
              }



            })

            if (this.uniqIdRadio.length > 0) {
              this.uniqIdRadio.forEach(itemNumbers => {
                if (itemNumbers != undefined) {
                  itemNumber.push(parseInt(itemNumbers.split("_")[0]))
                }
              })
              this.uniqIdRadio = []
            }
          }
          if (itemNumber.length > 0) {
            this.addModifierNumber.push(itemNumber)
          }
          else {
            this.addModifierNumber.push([])
          }

        }


        //check suggestedmodifierdata
        let available = [];
        let include = [];
        let sugAvailables = [];
        let suginclude = [];
        let addSuggestedModifiers = [];

        if (this.suggestedmodifierdata.available.length > 0 || this.suggestedmodifierdata.included.length > 0) {
          this.itemsofitemsNumber.forEach(itemdata => {
            for (var i = 0; i < this.suggestedmodifierdata.available.length; i++) {
              if (itemdata == this.suggestedmodifierdata.available[i].item_number) {
                available.push(this.suggestedmodifierdata.available[i]);
              }
            }
          })
        }
        sugAvailables = available;

        if (this.suggestedmodifierdata.available.length > 0 || this.suggestedmodifierdata.included.length > 0) {
          this.itemsofitemsNumber.forEach(itemdata => {
            for (var i = 0; i < this.suggestedmodifierdata.included.length; i++) {
              if (itemdata == this.suggestedmodifierdata.included[i].item_number) {
                include.push(this.suggestedmodifierdata.included[i]);
              }
            }
          })
        }
        suginclude = include;

        for (let i = 0; i < suginclude.length; i++) {
          addSuggestedModifiers.push(suginclude[i].modifier_item_number);
        }
        // Send the quantity data start
        this.nestedModifiers.forEach(quantityData => {
          this.itemsofitemsNumber.forEach(itemNumber => {
            if (quantityData.item_number == itemNumber) {
              this.quantitydata.push(quantityData.quantity)
            }
          })
        })
        // Send the quantity data start
        for (let j = 0; j < this.itemsofitemsNumber.length; j++) {
          // assign selected time when adding item to cart capacity item for child item start
          this.isReserves.time = 'null';
          if (this.selectedCapacityTime != undefined) {
            this.selectedCapacityTime.forEach((element, index) => {

              let convtStrtotime = element.split('=')[1];
              if (this.nestedModifiers != undefined) {
                this.nestedModifiers.forEach(data => {

                  if (data.availability) {
                    if (element.split('_')[0] == this.itemsofitemsNumber[j]) {
                      this.isReserves.time = convtStrtotime;
                    }
                    else {
                      this.isReserves.time = 'null';
                    }
                  }
                })
              }
            })
            this.isReserves.date = this.activeCalendarDate;
          }
          // assign selected time when adding item to cart capacity item for child item end

          if (this.items.length > 0) {
            let tempCount = 0;
            this.items.forEach(data => {
              if (data.item_number == this.itemsofitemsNumber[j]) {
                tempCount++;
                if (data.add_modifiers != undefined) {
                  data.add_modifiers = data.add_modifiers.concat(this.addModifierNumber[j]);
                }
              }
            })

            if (tempCount == 0) {
              this.items.push({ "item_number": this.itemsofitemsNumber[j], "quantity": this.quantitydata[j], "add_suggested_modifiers": addSuggestedModifiers, "add_modifiers": this.addModifierNumber[j], "add_special_instructions": this.addSpecialInstructions, "reservation": this.isReserves })
            }
          }
          else {
            this.items.push({ "item_number": this.itemsofitemsNumber[j], "quantity": this.quantitydata[j], "add_suggested_modifiers": addSuggestedModifiers, "add_modifiers": this.addModifierNumber[j], "add_special_instructions": this.addSpecialInstructions, "reservation": this.isReserves })
          }
        }


      }
    }


    // find selected items sums
    this.ItemSum = 0;
    this.selectedModsQty.forEach((element) => {
      if (element.quantity) {
        this.ItemSum += element.quantity;
      }
    });

    this.modgroupItemQtyTotal = this.ItemSum > 0 ? this.ItemSum : this.modgroupItemQtyTotal;
    this.modgroupItemQtyTracker = this.selectedModsQty;

    if (this.min > 0 && this.modgroupItemQtyTotal < this.min) {
      this.openAlertModal(this.maxSelectModifier);
      this.minMaxError = `Please add at least ${this.min} item(s)`;
    }
    else {
      this.modgroupItemQtyTotal = 0;
      this.modgroupItemQtyTracker = [];
      /*****testing*/
      this.modGroupCounter += 1;
      let elm = document.getElementById("modifierPrevButton");
      if (elm.classList.contains("dim-80")) {
        elm.classList.remove("dim-80");
      }
      elm.style.visibility = "visible";
      /*****end testing*/
      if (this.modgroupQtyItems) {
        var ln = this.modgroupQtyItems.length
        for (i = 0; i < ln; i++) {
          var ittmNumm = this.modgroupQtyItems[i];
          this.modgroupItem.push(ittmNumm);
        }
      }
      this.modgroupQtyItems = [];
      var i = 1 + index;

      if (this.modifier.length > i) {
        this.modifierGroup = this.modifier[i].modifiers;
        this.modifierCaption = this.modifier[i].caption;
        this.max = this.modifier[i].max;
        this.min = this.modifier[i].min;
        this.allowMultiple = this.modifier[i].allow_multiple;
        this.index = i;
        setTimeout(() => { this.setPreviousMods(); }, 200)
        setTimeout(() => { this.assignSelectedMods(); }, 500)
      }
      else if (this.nestedModifiers.length > 0) {

        this.modgroupItem.push(this.modGroupSecond)
        this.storeSelectItems(this.modGroupSecond, 'rd_01');
        if (this.modsIndex < this.nestedMods.length) {
          this.modifierGroup = this.nestedMods[this.modsIndex].modifiers;
          this.modifierCaption = this.nestedMods[this.modsIndex].caption;
          this.captionText = this.nestedMods[this.modsIndex].insideCaption;
          this.itemsofitemsNumber.push(this.nestedMods[this.modsIndex].itemNumber);
          this.max = this.nestedMods[this.modsIndex].max;
          this.min = this.nestedMods[this.modsIndex].min;
          this.allowMultiple = this.nestedMods[this.modsIndex].allow_multiple;
          this.indexTo = this.modsIndex;
          this.modsIndex++;
          setTimeout(() => { this.setPreviousMods(); }, 200)
          setTimeout(() => { this.assignSelectedMods(); }, 500)
        }
        else {
          this.modsIndex = 0;
          this.closeSuggestionPop();

          // we are showing special instruction based on conditions.
          if (this.requires_reservation == false && this.allowSpecialInstructions == undefined) {
            if (this.requires_reservation == false && (this.internal_menu && this.internal_menu != undefined)) this.openInstructionModal(this.instructContent);
            else this.manualPlaceOrder(true);
          }
          else {
            if (this.requires_reservation == false && this.allowSpecialInstructions) this.openInstructionModal(this.instructContent);
            else this.manualPlaceOrder(true);
          }

        }
      }
      else {
        this.modgroupItem.push(this.modGroupSecond)
        this.closeSuggestionPop();

        // we are showing special instruction based on conditions.
        if (this.requires_reservation == false && this.allowSpecialInstructions == undefined) {
          if (this.requires_reservation == false && (this.internal_menu && this.internal_menu != undefined)) this.openInstructionModal(this.instructContent);
          else this.manualPlaceOrder(true);
        }
        else {
          if (this.requires_reservation == false && this.allowSpecialInstructions) this.openInstructionModal(this.instructContent);
          else this.manualPlaceOrder(true);
        }

      }
    }
  }

  removeDuplicates(arr) {
    var unique = [];
    arr.forEach(element => {
      if (!unique.includes(element)) {
        unique.push(element);
      }
    });
    return unique;
  }

  countCharaceter() {
    let contentLength = this.instructionMsg.length;
    this.countTypeCharacter = contentLength;
  }

  maxOneSelect(id, parentId) {
    var uniqueId = `${id}_${parentId}`
    let itemNumberArray = [];
    itemNumberArray.push(id)
    this.compareRadioItemNumber.push(id)
    if (this.uniqIdRadio.length > 0) {
      this.uniqIdRadio.forEach(item => {
        this.uniqIdRadio.pop();
        this.uniqIdRadio.push(uniqueId)
      })
    }
    else {
      this.uniqIdRadio.push(uniqueId)
    }
    var rdbutton = document.getElementById("rd_" + id)
    this.modGroupSecond = uniqueId;
    this.nextButtonDisabled = false;
    let elm = document.getElementById("modifierNextButton");
    if (elm.classList.contains("dim-80")) {
      elm.classList.remove("dim-80");
    }
    this.modgroupItemQtyTotal = 1;
  }

  manualPlaceOrder(Id) {

    var item = this.itemId;
    var pageInfo = this.customPageData;
    var deliveryType = "Manual Location";
    var index = pageInfo.delivery_locations.findIndex((x) => x.id === Id);

    if (index > -1 && index < pageInfo.delivery_locations.length) {
      this.deliveryLocation = pageInfo.delivery_locations[index];
      this.deliveryLocationID = Id;
    }

    this.deliveryLocation = this.deliveryLocationName;

    if (this.popQty == false) {
      this.popQty = false;
      var quantity = this.pageQty;
      // quantity, item ,addModifiers, deliveryLocation, deliveryType, addSpecialInstructions
      this.addItemToOrderProcess(quantity, item, deliveryType, this.deliveryLocation);
    }
    else {
      var quantity = this.orderQty;
      this.addItemToOrderProcess(quantity, item, deliveryType, this.deliveryLocation);
    }
  }


  addItemToOrderProcess(quantity, item, deliveryType, deliveryLocation) {

    let includedMod = this.sugIncluded;
    let addSuggestedModifiers = [];
    if (quantity != null && item != null) {
      var addModifiers = [];
      for (var i = 0; i < includedMod.length; i++) {
        addSuggestedModifiers.push(includedMod[i].modifier_item_number);
      }
      if (this.modgroupItem.length > 0) {
        let splitItemNumber = []
        this.modgroupItem.forEach(element => {
          if (element != undefined) {
            let seprateItemNuber = element;
            splitItemNumber.push(parseInt(seprateItemNuber.split('_')[0]))
          }
        })
        splitItemNumber.forEach(itemsnumber => {
          this.parentmodifierData.forEach(matchItems => {
            if (itemsnumber == matchItems.item_number) {
              addModifiers.push(itemsnumber);
            }
          })
        })

      }
      // assign selected time when adding item to cart capacity item for child item start

      if (this.selectedCapacityTime != undefined) {
        let addSuggestedModifiers = [];
        let convtStrtotime = []

        this.selectedCapacityTime.forEach((element, index) => {
          if (this.nestedModifiers != undefined) {
            this.nestedModifiers.forEach((data) => {
              if (data.availability) {
                if (element.split('_')[0] == data.item_number) {
                  convtStrtotime.push(element.split('=')[1]);
                  let isReserves: any = {}
                  isReserves.date = this.activeCalendarDate;
                  isReserves.time = convtStrtotime[index];
                  let item_number = parseInt(element.split('_')[0])
                  this.items.push({ "item_number": item_number, "quantity": this.itemQuantity, "add_suggested_modifiers": addSuggestedModifiers, "add_modifiers": this.addModifierNumber, "add_special_instructions": this.addSpecialInstructions, "reserve": isReserves })
                }
              }
            })
          }
        })

      }
      // assign selected time when adding item to cart capacity item for child item start


      if (this.items != undefined) {
        this.selectedNestedItems = this.items;
      } else {
        this.selectedNestedItems = [];
      }

      this.addToCart(parseInt(quantity), item.item_number, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, this.addSpecialInstructions, this.selectedNestedItems);

    }
  }

  addToCart(quantity, itemNumber, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, addSpecialInstructions, selectedNestedItems) {

    this.addToCartloader = true;
    const addToCart = 'Add to Cart';
    const addedToCart = 'Added to Cart';
    let currentAddToCartClick = '';

    if (!this.requires_reservation) {
      let cartText = document.getElementById(itemNumber).innerHTML;
      currentAddToCartClick = cartText.trim();

    }
    else {
      currentAddToCartClick = 'Add to Cart';
    }


    if (currentAddToCartClick === addToCart) {
      const addToCartObservable = this.idealsOneApiService.addItemToOrderReq(this.isReserve, quantity, itemNumber, addSuggestedModifiers, addModifiers, deliveryLocation, deliveryType, addSpecialInstructions, selectedNestedItems);
      // const currentButtonClick = document.getElementById(itemNumber).innerHTML;
      addToCartObservable.subscribe((cartStatusData: any) => {
        this.addTocartStatus = cartStatusData;

        if (this.addTocartStatus.data.success === false) {
          this.addToCartloader = false;
          document.getElementById('openAddToCartErrorModel').click();
          this.addTocartError = this.addTocartStatus.data.error;
        }
        else {
          // update availability items when are adding item to cart page
          this.modgroupItem = [];
          this.modsIndex = 0;
          this.indexTo = -1;
          this.selectedModsQty = [];
          this.nestedMods = [];
          this.quantitydata = [];
          this.addModifierNumber = [];
          this.items = [];
          this.itemsofitemsNumber = [];
          this.parentmodifierData = [];
          sessionStorage.removeItem('selectedmodifiers');
          sessionStorage['addedItemsTocart'] = JSON.stringify(cartStatusData);
          // calling orderStatus Api to get cart_items_count
          const orderStatusObservableResponse = this.idealsOneApiService.orderStatusReq();
          orderStatusObservableResponse.subscribe((orderStatusData: any) => {

            this.orderStatus = orderStatusData;
            if (this.orderStatus.data.items) {

              this.cartItemsCount = this.orderStatus.data.items.length;
            }
            else {
              this.cartItemsCount = undefined;
            }
            // update page info only for reservation page
            if (this.requires_reservation) this.getPageId();
          });

          const cartItemLength = this.addTocartStatus.data.items.length;
          const pageInfoItemLength = this.pageInformations.data.body.items.length;

          for (let cartItm = 0; cartItm < cartItemLength; cartItm++) {

            for (let pageinfoItem = 0; pageinfoItem < pageInfoItemLength; pageinfoItem++) {
              // tslint:disable-next-line:max-line-length
              if ((this.addTocartStatus.data.items[cartItm].item_number === this.pageInformations.data.body.items[pageinfoItem].item_number) && this.addTocartStatus.data.items[cartItm].item_number === itemNumber) {
                const cartItmId = this.addTocartStatus.data.items[cartItm].item_number;
                document.getElementById(cartItmId + 'qnt').className = 'btn btn-delete-cart';

                if (!this.requires_reservation) {
                  const addCartElement = document.getElementById(cartItmId);
                  addCartElement.className = 'addcart-arrow';
                  addCartElement.innerHTML = addedToCart;
                  setTimeout(() => {
                    const addCartElement = document.getElementById(cartItmId);
                    addCartElement.className = 'addcart';
                    addCartElement.innerHTML = addToCart;
                  }, 1800);
                }
                setTimeout(() => { this.addToCartloader = false; }, 2000)
                // setTimeout(() => {
                //   this.addToCartloader = false;
                //   if (!this.isCartItems && !this.isCustomerLogin) this.openCustomerModal(this.customerContents)
                //   this.isCartItems = true;
                // }, 2000)
              }
            }
          }
        }
      });
    }
  }

  pageResubmit(event: any) {

    // selecting current date box when user will click on Box
    this.activeDay = event.day;
    let dateBoxItems = document.querySelectorAll('.BoxWeek h2');
    this.weeklyCalendar.forEach(function (i) {

      if (i.date == event.day) {
        dateBoxItems.forEach(function (item) {
          item.classList.remove('activeDate');
        });
        let activeDate = document.getElementById('date' + event.day);
        activeDate.className = 'activeDate';
      }
    });

    this.isCalenderClick = true;
    let eveDate = undefined;
    let eveMonth = undefined;
    event.month.toString().length == 1 ? eveMonth = "0" + event.month : eveMonth = event.month;
    event.day.toString().length == 1 ? eveDate = "0" + event.day : eveDate = event.day;
    let isoDate = new Date(`${event.year}-${eveMonth}-${eveDate}T00:00:00Z`).toISOString();
    this.pageidPassword.reservation_date = isoDate;
    this.checkRequiresReservation = [];
    this.getPageId(true);
  }

  onDateSelect(event: any) {
    this.pageResubmit(event);
    this.futureClickDate = new Date(`${event.year}/${event.month}/${event.day}`);
    this.getDateCalendar();
    // selecting current date box when user will click on Box
    let dateBoxItems = document.querySelectorAll('.BoxWeek h2');
    this.weeklyCalendar.forEach(function (i) {

      if (i.date == event.day) {
        dateBoxItems.forEach(function (item) {
          item.classList.remove('activeDate');
        });
        let activeDate = document.getElementById('date' + event.day);
        if (activeDate != null) {
          activeDate.className = 'activeDate';
        }
      }
    });
  }

  updateAvailableTimes = (selectedQty, itemNumber) => {

    const updatedAvailability = [];

    for (let i = 0; i < this.ticketData.length; i++) {

      if (this.ticketData[i].item_number === itemNumber) {

        let pageInformationObservables = this.idealsOneApiService.pageInformationReq(this.pageidPassword);
        pageInformationObservables.subscribe((pageInformationData1: any) => {
          this.pageInformations = pageInformationData1;

          if (this.pageInformations.data.body.items) {
            this.fetchTicketData = this.pageInformations.data.body.items;
          }

          this.fetchTicketData.forEach((item) => {

            if (item.item_number === itemNumber) {

              for (let i = 0; i < item.availability.times.length; i++) {
                if (item.availability.times[i].available_items >= selectedQty) {
                  updatedAvailability.push(item.availability.times[i]);
                }
              }
            };
          })

          this.ticketData[i].availability.times = updatedAvailability;
        });
        break;
      }
    }
  }

  changeQnt(itemNumber: any, ticket, event) {

    const addToCart = 'Add to Cart';
    const addedToCart = 'Added to Cart';
    const pageInfoItemLength = this.pageInformations.data.body.items.length;
    this.selectedQty = event.target.value;

    // here we have create unique array of object
    let obj = { qtySelectionNo: itemNumber, quantity: event.target.value };
    this.allQtySelection.push(obj);
    var flags = {};

    var uniqueQty = this.allQtySelection.filter(function (entry) {
      if (flags[entry.qtySelectionNo]) {
        return false;
      }
      flags[entry.qtySelectionNo] = true;
      return true;
    });

    uniqueQty.forEach(function (item, index, theArray) {
      if (item.qtySelectionNo == itemNumber) {
        theArray[index].quantity = parseInt(event.target.value);
      }
    })

    this.allQtySelection = uniqueQty;    // here end unique array of object code

    for (let pageinfoItem = 0; pageinfoItem < pageInfoItemLength; pageinfoItem++) {
      if (itemNumber === this.pageInformations.data.body.items[pageinfoItem].item_number) {

        if (!this.requires_reservation) {
          const cartItmId = itemNumber;
          const addCartElement = document.getElementById(cartItmId);
          addCartElement.className = 'addcart';
          addCartElement.innerHTML = addToCart;
        }
      }
    }

    // Filter available times based on quantity selection.
    if (this.requires_reservation) {
      this.ticketData.forEach(element => {
        if (element.item_number === itemNumber) {
          this.updateAvailableTimes(this.selectedQty, element.item_number)
        }
      });
    }
  }

  checkOrderStatus = () => {

    const orderStatusObservable = this.idealsOneApiService.orderStatusReq();
    orderStatusObservable.subscribe((orderStatusData: any) => {
      this.orderStatus = orderStatusData;
      if (this.orderStatus.data.items) {
        this.addedItemsStatus = this.orderStatus.data.items;
        const addToCart = 'Add to Cart';
        const addedToCart = 'Added to Cart';
        let itemLengthOfpageInfo: any;
        const itemLength = this.orderStatus.data.items.length;
        this.cartItemsCount = this.orderStatus.data.items.length;
        let currentAddToCartvalue = '';
        this.isCartItems = true;
        if (this.pageInformations.data.body.items) {
          itemLengthOfpageInfo = this.pageInformations.data.body.items.length;
        }

        for (let index = 0; index < itemLength; index++) {

          for (let indexOfpageInfo = 0; indexOfpageInfo < itemLengthOfpageInfo; indexOfpageInfo++) {
            // tslint:disable-next-line:max-line-length
            if (this.pageInformations.data.body.items[indexOfpageInfo].item_number && this.orderStatus.data.items[index].item_number === this.pageInformations.data.body.items[indexOfpageInfo].item_number) {

              if (!this.requires_reservation) {
                currentAddToCartvalue = document.getElementById(this.orderStatus.data.items[index].item_number).innerHTML;
              } else {
                currentAddToCartvalue = 'Add to Cart';
              }

              if (currentAddToCartvalue === addToCart) {
                const cartItmId = this.orderStatus.data.items[index].item_number;
                document.getElementById(cartItmId + 'qnt').className = 'btn btn-delete-cart';

                for (let item = 0; item < itemLength; item++) {
                  this.selectFormName = this.orderStatus.data.items[item].item_number;
                  this.quantityForm.patchValue({ [this.selectFormName]: this.orderStatus.data.items[item].quantity });
                }

              }
            }
          }

        }

        this.loader = false;

      } else {
        this.loader = false;
        this.cartItemsCount = undefined;
        this.isCartItems = false;
      }
    });
  }


  btnControls(pagecontrol: any) {

    if (this.suggetionModalStatus) {
      this.closeSuggestionPop();
    }
    switch (pagecontrol.item_type) {
      case configMsg.completeSale: {
        this.router.navigateByUrl('/payment');
        break;
      }

      case configMsg.goTopage: {
        this.loader = true;
        const queryParams: Params = { page: pagecontrol.go_page_id };
        this.router.navigate(
          [],
          {
            relativeTo: this.activatedRoute,
            queryParams: queryParams,
            queryParamsHandling: '' // remove to replace all query params by provided
          });

        setTimeout(() => { this.getPageId(); }, 100);
        break;
      }

      default: {
        console.log('No controls-----');
        break;
      }
    }
  }

  navBtnControls(navigation: any) {
    this.selectedCapacityTime = []
    switch (navigation.item_type) {
      case configMsg.completeSale: {
        this.router.navigateByUrl('/payment');
        break;
      }

      case configMsg.goTopage: {
        this.loader = true;
        // this.addToCartloader = true;
        const queryParams: Params = { page: navigation.go_page_id };
        this.router.navigate(
          [],
          {
            relativeTo: this.activatedRoute,
            queryParams: queryParams,
            queryParamsHandling: '' // remove to replace all query params by provided
          });
        setTimeout(() => { this.getPageId(); }, 100);
        break;
      }

      default: {
        console.log('No controls-----');
        // this.router.navigateByUrl('/?payment=test');
        break;
      }
    }
  }

  headerBtnControls(headerNav: any) {

    switch (headerNav.item_type) {
      case configMsg.completeSale: {
        this.router.navigateByUrl('/payment');
        break;
      }

      case configMsg.goTopage: {
        this.loader = true;
        const queryParams: Params = { page: headerNav.go_page_id };
        this.router.navigate(
          [],
          {
            relativeTo: this.activatedRoute,
            queryParams: queryParams,
            queryParamsHandling: '' // remove to replace all query params by provided
          });
        setTimeout(() => { this.getPageId(); }, 100);
        break;
      }

      default: {
        console.log('No controls-----');
        break;
      }
    }
  }

  // Quantity list till 10
  getQuantityList() {
    const qnt = 1;

    for (let index = 0; index <= 9; index++) {
      this.quantityList.push(qnt + index);
    }
  }

  getDateCalendar() {


    if (this.showDateWidth > 550) {
      let availabilityDate = new Date();
      let serverDate = undefined;

      if (this.ticketData[0].availability) {
        availabilityDate = this.ticketData[0].availability.date;
        serverDate = availabilityDate.toString().split('.')[0];

      } else {
        this.ticketData.forEach((val, index, theArray) => {
          this.ticketinItems.push(val.items)
          for (let data in val.items) {
            this.itemofitemData.push(val.items[data])
          }

        })
        this.itemofitemData.forEach(itemData => {
          if (this.ticketinItems.length && itemData.availability) {
            availabilityDate = itemData.availability.date;
            serverDate = availabilityDate.toString().split('.')[0];
          }
        })
      }

      let currDate = this.futureClickDate ? this.futureClickDate : new Date(`${serverDate}`);
      this.activeDay = currDate.getDate();
      this.minDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let weeklyCalendar = [];
      let daysCount = 6;
      let currCount = 1;
      let nextCount = 1;
      for (let i = 1; i <= daysCount; i++) {
        if (currCount == 1) {
          let date = currDate.getDate();
          let monthString = months[currDate.getMonth()];
          let monthNumber = currDate.getMonth() + 1;
          let day = currDate.toLocaleString("default", { weekday: "long" });
          let year = currDate.getFullYear();
          weeklyCalendar.push({ date: date, monthString: monthString, monthNumber: monthNumber, day: day, year: year });
          currCount++
        }
        else {
          let tomorrow = new Date(currDate);
          tomorrow.setDate(tomorrow.getDate() + nextCount)
          let date = tomorrow.getDate();
          let monthString = months[tomorrow.getMonth()];
          let monthNumber = tomorrow.getMonth() + 1;
          let day = tomorrow.toLocaleString("default", { weekday: "long" });
          let year = tomorrow.getFullYear();
          weeklyCalendar.push({ date: date, monthString: monthString, monthNumber: monthNumber, day: day, year: year });
          nextCount++;
        }
      }
      this.weeklyCalendar = weeklyCalendar;
    } else {
      let availabilityDate = new Date();
      let serverDate = undefined;

      if (this.ticketData[0].availability) {
        availabilityDate = this.ticketData[0].availability.date;
        serverDate = availabilityDate.toString().split('.')[0];
      }

      let currDate = this.futureClickDate ? this.futureClickDate : new Date(`${serverDate}`);
      this.activeDay = currDate.getDate();
      this.minDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() };
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let weeklyCalendar = [];
      let daysCount = 3;
      let currCount = 1;
      let nextCount = 1;
      for (let i = 1; i <= daysCount; i++) {
        if (currCount == 1) {
          let date = currDate.getDate();
          let monthString = months[currDate.getMonth()];
          let monthNumber = currDate.getMonth() + 1;
          let day = currDate.toLocaleString("default", { weekday: "long" });
          let year = currDate.getFullYear();
          weeklyCalendar.push({ date: date, monthString: monthString, monthNumber: monthNumber, day: day, year: year });
          currCount++
        }
        else {
          let tomorrow = new Date(currDate);
          tomorrow.setDate(tomorrow.getDate() + nextCount)
          let date = tomorrow.getDate();
          let monthString = months[tomorrow.getMonth()];
          let monthNumber = tomorrow.getMonth() + 1;
          let day = tomorrow.toLocaleString("default", { weekday: "long" });
          let year = tomorrow.getFullYear();
          weeklyCalendar.push({ date: date, monthString: monthString, monthNumber: monthNumber, day: day, year: year });
          nextCount++;
        }
      }
      this.weeklyCalendar = weeklyCalendar;

    }

  }

  onResizes(event) {
    this.showDateWidth = event.target.innerWidth;
    this.getDateCalendar();

  }

  onResize(event) {

    this.screenWidth = event.target.innerWidth;
    this.manageNavigation();

  }
  // manage the collaspe of navigation and dropdown 
  manageNavigation() {

    let headerMenu = document.getElementById('parentNavigation');
    let children = Array.from(headerMenu.children).length;
    let childrens = Array.from(headerMenu.children)
    let collapCount = document.getElementById('navbarSupportedContent');
    let collapChild = collapCount.querySelectorAll('li');
    if (children > 7) {
      let arr = [];
      let collaparr = [];

      for (let i = 0; i <= childrens.length - 1; i++) {
        if (i < 7) {
          arr.push(childrens[i].id)
        }
      }
      for (let j = collapChild.length - 1; j >= 0; j--) {
        if (j < 7) {
          collaparr.push(collapChild[j].id)
        }
      }

      if (this.screenWidth < 1200) {
        document.getElementById(arr[6]).style.display = "none";
        document.getElementById(collaparr[0]).style.display = "block";

      } else {
        document.getElementById(arr[6]).style.display = "block";
        document.getElementById(collaparr[0]).style.display = "none";

      }
      if (this.screenWidth < 1000) {
        document.getElementById(arr[4]).style.display = "none";
        document.getElementById(arr[5]).style.display = "none";
        document.getElementById(collaparr[2]).style.display = "block";
        document.getElementById(collaparr[1]).style.display = "block";
        document.getElementById('parentNavigation').style.display = "block"
      } else {
        document.getElementById(arr[4]).style.display = "";
        document.getElementById(arr[5]).style.display = "";
        document.getElementById(collaparr[2]).style.display = "";
        document.getElementById(collaparr[1]).style.display = "";
        document.getElementById('parentNavigation').style.display = "contents"
      }
      if (this.screenWidth < 770) {
        document.getElementById(arr[3]).style.display = "none";
        document.getElementById(collaparr[3]).style.display = "block";
      } else {
        document.getElementById(arr[3]).style.display = "";
        document.getElementById(collaparr[3]).style.display = "";
      }
      if (this.screenWidth < 534) {
        document.getElementById(arr[2]).style.display = "none";
        document.getElementById(collaparr[4]).style.display = "block";
      } else {
        document.getElementById(arr[2]).style.display = "";
        document.getElementById(collaparr[4]).style.display = "";
      }

      if (this.screenWidth < 376) {
        document.getElementById(arr[1]).style.display = "none";
        document.getElementById(collaparr[5]).style.display = "block";
      } else {
        document.getElementById(arr[1]).style.display = "";
        document.getElementById(collaparr[5]).style.display = "";
      }
    }


    if (children == 7) {
      if (this.screenWidth < 1200) {
        document.getElementById('defaultnav7').style.display = "none";
        document.getElementById('defaultnav6').style.display = "none";
        document.getElementById('collapsenav14').style.display = "block";
        document.getElementById('collapsenav13').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav7').style.display = "block";
        document.getElementById('defaultnav6').style.display = "block";
        document.getElementById('collapsenav14').style.display = "none";
        document.getElementById('collapsenav13').style.display = "none";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }
      if (this.screenWidth < 1000) {

        document.getElementById('defaultnav5').style.display = "none";

        document.getElementById('collapsenav12').style.display = "block";

        document.getElementById('parentNavigation').style.display = "block"
      } else {
        document.getElementById('defaultnav6').style.display = "";
        document.getElementById('defaultnav5').style.display = "";
        document.getElementById('collapsenav13').style.display = "";
        document.getElementById('collapsenav12').style.display = "";

        document.getElementById('parentNavigation').style.display = "contents"
      }
      if (this.screenWidth < 770) {
        document.getElementById('defaultnav4').style.display = "none";
        document.getElementById('collapsenav11').style.display = "block";
      } else {
        document.getElementById('defaultnav4').style.display = "";
        document.getElementById('collapsenav11').style.display = "";
      }
      if (this.screenWidth < 534) {
        document.getElementById('defaultnav3').style.display = "none";
        document.getElementById('collapsenav10').style.display = "block";
      } else {
        document.getElementById('defaultnav3').style.display = "";
        document.getElementById('collapsenav10').style.display = "";
      }
      if (this.screenWidth < 376) {
        document.getElementById('defaultnav2').style.display = "none";
        document.getElementById('collapsenav9').style.display = "block";
      } else {
        document.getElementById('defaultnav2').style.display = "";
        document.getElementById('collapsenav9').style.display = "";
      }
    }
    else if (children == 6) {
      if (this.screenWidth < 1200) {
        document.getElementById('defaultnav6').style.display = "none";
        document.getElementById('collapsenav13').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav6').style.display = "block";
        document.getElementById('collapsenav13').style.display = "none";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }
      if (this.screenWidth < 1000) {
        document.getElementById('defaultnav5').style.display = "none";
        document.getElementById('defaultnav4').style.display = "none";

        document.getElementById('collapsenav12').style.display = "block";
        document.getElementById('collapsenav11').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav5').style.display = "block";
        document.getElementById('collapsenav12').style.display = "none";
        document.getElementById('defaultnav4').style.display = "";
        document.getElementById('collapsenav11').style.display = "";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }

      if (this.screenWidth < 776) {
        document.getElementById('defaultnav3').style.display = "none";
        document.getElementById('collapsenav10').style.display = "block";
      } else {
        document.getElementById('defaultnav3').style.display = "";
        document.getElementById('collapsenav10').style.display = "";
      }
      if (this.screenWidth < 356) {
        document.getElementById('defaultnav2').style.display = "none";
        document.getElementById('collapsenav9').style.display = "block";
      } else {
        document.getElementById('defaultnav2').style.display = "";
        document.getElementById('collapsenav9').style.display = "";
      }
    }


    else if (children == 5) {
      if (this.screenWidth < 850) {
        document.getElementById('defaultnav5').style.display = "none";
        document.getElementById('collapsenav12').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav5').style.display = "block";
        document.getElementById('collapsenav12').style.display = "none";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }
      if (this.screenWidth < 768) {
        document.getElementById('defaultnav4').style.display = "none";
        document.getElementById('collapsenav11').style.display = "block";
        document.getElementById('parentNavigation').style.display = "block"
      } else {
        document.getElementById('defaultnav4').style.display = "";
        document.getElementById('collapsenav11').style.display = "";
        document.getElementById('parentNavigation').style.display = "contents"
      }
      if (this.screenWidth < 550) {
        document.getElementById('defaultnav3').style.display = "none";
        document.getElementById('collapsenav10').style.display = "block";
      } else {
        document.getElementById('defaultnav3').style.display = "";
        document.getElementById('collapsenav10').style.display = "";
      }
      if (this.screenWidth < 396) {
        document.getElementById('defaultnav2').style.display = "none";
        document.getElementById('collapsenav9').style.display = "block";
      } else {
        document.getElementById('defaultnav2').style.display = "";
        document.getElementById('collapsenav9').style.display = "";
      }
    }

    else if (children == 4) {
      if (this.screenWidth < 768) {
        document.getElementById('defaultnav4').style.display = "none";
        document.getElementById('collapsenav11').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav4').style.display = "block";
        document.getElementById('collapsenav11').style.display = "none";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }
      if (this.screenWidth < 550) {
        document.getElementById('defaultnav3').style.display = "none";
        document.getElementById('collapsenav10').style.display = "block";
      } else {
        document.getElementById('defaultnav3').style.display = "";
        document.getElementById('collapsenav10').style.display = "";
      }
      if (this.screenWidth < 400) {
        document.getElementById('defaultnav2').style.display = "none";
        document.getElementById('collapsenav9').style.display = "block";
      } else {
        document.getElementById('defaultnav2').style.display = "";
        document.getElementById('collapsenav9').style.display = "";
      }
    }

    else if (children == 3) {
      if (this.screenWidth < 500) {
        document.getElementById('defaultnav3').style.display = "none";
        document.getElementById('collapsenav10').style.display = "block";
        document.querySelector<HTMLElement>('.colNav').style.display = "block"
      } else {
        document.getElementById('defaultnav3').style.display = "block";
        document.getElementById('collapsenav10').style.display = "none";
        document.querySelector<HTMLElement>('.colNav').style.display = "none"
      }
      if (this.screenWidth < 410) {
        document.getElementById('defaultnav2').style.display = "none";
        document.getElementById('collapsenav9').style.display = "block";
      } else {
        document.getElementById('defaultnav2').style.display = "";
        document.getElementById('collapsenav9').style.display = "";
      }
    }
  }

  // here we are showing closed message and warning message on product page.
  checkShopStatus() {

    let openTime, closeTime, waitTime, difference, curDTime, weekday, daysArray;
    daysArray = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    curDTime = moment().utc().format();
    weekday = daysArray[moment.utc().format("e")];
    openTime = moment.utc(this.operatingSchedule[weekday].open).format();
    closeTime = moment.utc(this.operatingSchedule[weekday].close).format();
    difference = moment.utc(this.operatingSchedule[weekday].close).diff(curDTime, 'minutes');
    waitTime = Math.round(difference);

    if ((curDTime >= openTime && curDTime <= closeTime) && waitTime > this.operatingSchedule.warning_minutes) {
      this.warningMessage = '';
    }
    else if (waitTime > 0 && waitTime <= this.operatingSchedule.warning_minutes) {
      this.warningMessage = this.operatingSchedule.warning_message;
    }
    else {
      this.warningMessage = this.operatingSchedule.closed_message;
    }
  }

  openLoginDialog(login) {
    this.openLoginModal(login)
  }

  closeLogin() {
    this.loginModalReference.close();
    this.isVerificationScreen = false;
    this.isEmail = false;
    this.isPhone = false;
    this.emailAddress = '';
    this.phoneNumber = '';
    this.isEmailError = '';
    this.isPhoneError = '';
    this.isDefault = true;
  }

  closeCustomer() {
    this.isCodeError = '';
    this.customerModalReference.close();
  }

  sendVerification() {

    if (this.emailAddress || this.phoneNumber) {
      const email_address = this.emailAddress ? this.emailAddress : '';
      const phone_number = this.phoneNumber ? this.phoneNumber : '';
      const vcode = this.verificationCode ? this.verificationCode : '';
      const applyCustomerObservable = this.idealsOneApiService.applyCustomerReq(email_address, phone_number, vcode);
      applyCustomerObservable.subscribe((customerData: any) => {

        if (customerData != undefined && customerData != "") {
          this.customerData = customerData;
          if (this.customerData.data.error) {

            if (this.emailAddress == undefined || this.emailAddress == '') {
              this.isPhoneError = this.customerData.data.error;
            }
            else {
              this.isEmailError = this.customerData.data.error;
            }

          } else {
            this.isEmailError = 'success';
            this.isVerificationScreen = true;
          }
        }

      });
      this.alertloginMessage = `Please check your ${this.emailAddress ? 'email' : 'phone'} for the code to enter here`;
    }
    else {
      return false;
    }
  }

  customerLogin(vcode: any) {

    if (vcode) {

      const email_address = this.emailAddress != undefined ? this.emailAddress : this.customerDetails.email != undefined ? this.customerDetails.email : '';
      const phone_number = this.phoneNumber != undefined ? this.phoneNumber : this.customerDetails.phone != undefined ? this.customerDetails.phone : '';
      const code = vcode.vcode ? vcode.vcode : '';

      const applyCustomerObservable = this.idealsOneApiService.applyCustomerReq(email_address, phone_number, code);
      applyCustomerObservable.subscribe((customerData: any) => {
        this.customerData = customerData;

        if (this.customerData.data.customer_information) {

          this.customerInformation = this.customerData.data.customer_information;
          this.customerProfile = this.customerInformation.image ? this.customerProfileUrl(this.customerInformation.image) : 'assets/img/user_profile.png';
          this.customerName = this.customerInformation.first_name || this.customerInformation.last_name ? `${this.customerInformation.first_name} ${this.customerInformation.last_name}` : 'Login';
          sessionStorage['customerInfo'] = JSON.stringify(this.customerInformation);
          this.isVerificationScreen = false;
          this.isCodeError = '';
          this.isCustomerLogin = true;
          if (!this.customerScreen) {
            this.customerModalReference.close();
            if (this.customerType === 'payment') setTimeout(() => { this.router.navigate(['/payment']) }, 1000)
          }
          else {
            this.loginModalReference.close();
          }
        }
        else {
          this.isCodeError = 'Invalid Verification Code ';
          this.isCustomerLogin = false;
        }

      });
    }
    else {
      return false;
    }
  }

  phoneVerification(event) {

    if (this.phoneNumber || this.emailAddress) {
      this.isDefault = false;
      const input = event.target.value ? event.target.value.toString() : 0;
      if (input.length == 10) {
        this.isEmail = true;
        this.isPhoneError = '';
      }
      else {
        this.isPhoneError = 'Please enter valid phone number';
        this.isEmail = true;
      }
    }
    else {
      this.isDefault = true;
      this.isPhoneError = '';
      this.isEmail = false;
    }
  }

  emailVerification(event: any) {

    if (this.emailAddress || this.phoneNumber) {

      this.isDefault = false;
      let inputval = event.target.value;
      var pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

      if (inputval.match(pattern)) {
        this.isEmailError = '';
        this.isPhone = true;
      } else {
        this.isEmailError = 'Please enter valid email';
        this.isPhone = true;
      }
    } else {
      this.isDefault = true;
      this.isEmailError = ''
      this.isPhone = false;
    }
  }

  preventCharacter(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 9) this.closeLogin();

    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode < 96 || charCode > 105) {
      return false;
    }
  }

  codeVerification(event: any) {
    if (event.target.value) {
      this.isEmailError = '';
    }
  }

  injectGlobalScript() {

    let headerScript = this.glocalHeader;
    let footerScript = this.glocalFooter;

    if (headerScript != "" && headerScript != undefined) {

      // remove commented lines from header
      let commentRegex = /(\<!--.*?\-->)/g;
      headerScript = headerScript.replace(commentRegex, "");

      // Get src value from header string & then append to head tag
      const regex = /<script.*?src=['"](.*?)['"]/;
      let src = regex.exec(headerScript)[1];
      let node = document.createElement('script');
      node.async = true;
      node.src = src;
      document.head.append(node);

      // extract first script  from header string
      let removeFirstScript = `<script async src="${src}"></script>`.trim();
      var secondScript = headerScript.replace(removeFirstScript, '').trim();
      let finalScript = secondScript.replace(/(<([^>]+)>)/gi, "").trim();;

      // append script code to header tag
      let nodeElement = document.createElement('script');
      let inlineScript = document.createTextNode(finalScript);
      nodeElement.appendChild(inlineScript);
      document.head.appendChild(nodeElement);
    }

    // Append footer script using the ID
    if (footerScript != "" && footerScript != undefined) {
      let removeDoctype = footerScript.replace('<!DOCTYPE html>', '').replace('</html>', '').trim();
      this.footerElement.innerHTML = removeDoctype;
    }
  }

  checkCustomer(regforms: any, type: any) {

    this.customerType = type;

    if (regforms.name == '' && (regforms.email == '' && regforms.phone == '')) {
      this.customerModalReference.close();
      if (this.customerType === 'payment') this.router.navigate(['/payment'])
    }
    else {
      let firstname = regforms.name != "" ? regforms.name.split(" ")[0] : "";
      let lastname = regforms.name != "" ? regforms.name.split(" ")[1] : "";

      let obj = { fname: firstname, lname: lastname, email: regforms.email, phone: regforms.phone };

      let applyObservable = this.idealsOneApiService.applyCustomerReq(regforms.email, regforms.phone, regforms.phone = "");
      applyObservable.subscribe((response: any) => {

        if (response.data.success) {
          this.customerDetails = obj;
          this.customerScreen = false;
        }
        else {
          sessionStorage.customerFormData = JSON.stringify(obj)
          if (this.customerType === 'shopping') this.customerModalReference.close();
          else if (this.customerType === 'payment') {
            this.customerModalReference.close();
            setTimeout(() => { this.router.navigate(['/payment']) }, 1000)
          }
        }
      });

      this.alertMessage = `Please check your ${regforms.email ? 'email' : 'phone'} for the code to enter here`;
    }
  }

  getGlobalScriptProperties() {

    if (this.siteInformations.data.global_header_html != '' && this.siteInformations.data.global_header_html != undefined)
      this.glocalHeader = this.siteInformations.data.global_header_html;

    if (this.siteInformations.data.global_footer_html != '' && this.siteInformations.data.global_footer_html != undefined)
      this.glocalFooter = this.siteInformations.data.global_footer_html;

    // Inject header and footer
    this.injectGlobalScript();

    // Injecting global properties into each page of oneweb
    if (this.siteInformations.data.global_script_urls != '' && this.siteInformations.data.global_script_urls != undefined) {
      this.global_script_urls = this.siteInformations.data.global_script_urls;
      if (Array.isArray(this.global_script_urls) && this.global_script_urls.length)
        this.global_script_urls.forEach((url) => { this.injectScriptUrl(url) })
      else
        this.injectScriptUrl(this.global_script_urls);
    }

    if (this.siteInformations.data.global_script_code != '' && this.siteInformations.data.global_script_code != undefined) {
      this.global_script_code = this.siteInformations.data.global_script_code;
      this.injectScriptCode(this.global_script_code);
    }


    if (this.siteInformations.data.global_css_urls != '' && this.siteInformations.data.global_css_urls != undefined) {
      this.global_css_urls = this.siteInformations.data.global_css_urls;
      if (Array.isArray(this.global_css_urls) && this.global_css_urls.length)
        this.global_css_urls.forEach((url) => { this.injectCSSURL(url) })
      else
        this.injectCSSURL(this.global_css_urls);
    }

    if (this.siteInformations.data.global_css_code != '' && this.siteInformations.data.global_css_code != undefined) {
      this.global_css_code = this.siteInformations.data.global_css_code;
      this.injectCSSCode(this.global_css_code);
    }

  }

  injectScriptUrl(url: any) {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = url;
    script.addEventListener('load', function (e: any) { console.log('loaded ' + url) });
    script.addEventListener('error', function (e: any) { alert('ERROR: ' + e.message) });
    script.addEventListener('abort', function (e: any) { alert('ABORT: ' + e.message) });
    document.head.appendChild(script);
  }

  injectScriptCode(code: any) {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    const url = URL.createObjectURL(new Blob([code]));
    script.src = url;
    script.addEventListener('load', function (e: any) { URL.revokeObjectURL(url) });
    script.addEventListener('error', function (e: any) { alert('ERROR: ' + e.message) });
    script.addEventListener('abort', function (e: any) { alert('ABORT: ' + e.message) });
    document.head.appendChild(script);
  }

  injectCSSURL(url: any) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', url);

    link.addEventListener('load', function (e: any) { console.log('loaded ' + url) });
    link.addEventListener('error', function (e: any) { alert('ERROR ' + e.message) });
    link.addEventListener('abort', function (e: any) { alert('ABORT ' + e.message) });
    document.head.appendChild(link);
  }

  injectCSSCode(code) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    const url = URL.createObjectURL(new Blob([code]));
    link.setAttribute('href', url);
    link.addEventListener('load', function (e: any) { URL.revokeObjectURL(url) });
    link.addEventListener('error', function (e: any) { alert('ERROR ' + e.message) });
    link.addEventListener('abort', function (e: any) { alert('ABORT ' + e.message) });
    document.head.appendChild(link);
  }
  // for customerProfile image senitize
  customerProfileUrl(ProfileUrl): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(ProfileUrl);
  }

  assignSelectedMods() {

    try {
      let sessionMods = sessionStorage.getItem('selectedmodifiers') ? JSON.parse(sessionStorage.getItem('selectedmodifiers')) : [];
      let currentScreenMods = [];

      if (sessionMods.length) {
        let newitemNumber;
        this.modifierGroup.forEach((val, index, theArray) => {
          newitemNumber = `${val.item_number}_${val.parentItemNumber}`
          sessionMods.forEach((element) => {
            if (newitemNumber == element.itemNumber) currentScreenMods.push(element);
          })
        })
      }

      if (currentScreenMods.length) {
        currentScreenMods.forEach((elem) => {
          let selectedCheckbox = (document.getElementById('chk_' + elem.itemNumber) as HTMLInputElement);
          if (selectedCheckbox != null) {
            if (selectedCheckbox.checked) {
              this.modgroupItemQtyTracker.push(elem);
            }
          }
        })

        this.modgroupItemQtyTotal = 0;
        for (let i = 0; i < this.modgroupItemQtyTracker.length; i++) {
          this.modgroupItemQtyTotal += this.modgroupItemQtyTracker[i].quantity;
        }
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  capacitySelectedTime(time: any, item, timeid, indexOfElement) {

    if (!this.checkArrayElementCount.includes(item.item_number)) {
      this.checkArrayElementCount.push(item.item_number)
    }
    this.timeSelection = time;
    if (this.selectedCapacityTime.length) {
      this.selectedCapacityTime.forEach((val, index) => {
        let splitValue = val.split('_');
        if (splitValue[0] == item.item_number) {
          let itemsSplit = val.split('=')[0];
          let time = document.getElementById(itemsSplit)
          time.style.background = '';
          time.style.color = '';
          this.selectedCapacityTime.splice(index, 1);
        }
        else if (splitValue[0] != item.item_number) {
          let itemsSplit = val.split('=')[0];
          let time = document.getElementById(itemsSplit)
          time.style.background = '';
          time.style.color = '';
          if (this.ticketsItemData == undefined) {
            this.selectedCapacityTime.splice(index, 1);
          }
        }
      })
      this.selectedCapacityTime.push(timeid != "" ? `${item.item_number}_${timeid}=${time}` : "");
    }
    else {
      this.selectedCapacityTime.push(timeid != "" ? `${item.item_number}_${timeid}=${time}` : "");
    }
    if (this.selectedCapacityTime.length && this.requires_reservation) {

      var filtered = this.selectedCapacityTime.filter(function (el) {
        return el != "";
      });

      this.ticketData.forEach((val) => {
        if (val.items) {
          val.items.forEach((itemData) => {
            if (itemData.item_number == item.item_number) {
              this.ticketsItemData = val.items;
            }
          });
        }
      });

      if (this.ticketsItemData) {
        setTimeout(() => {
          filtered.forEach((val) => {
            let itemsSplit = val.split('=')[0];
            let time = document.getElementById(itemsSplit)
            time.style.background = '#08507d';
            time.style.color = 'white';
            if (this.checkItemNumberForLength[indexOfElement].length == this.checkArrayElementCount.length) {
              document.getElementById('unable_' + indexOfElement).style.display = 'block';
              document.getElementById('disable_' + indexOfElement).style.display = 'none';
            }
          })
        }, 200);
      }
      else {
        setTimeout(() => {
          filtered.forEach((val) => {
            let itemsSplit = val.split('=')[0];
            let time = document.getElementById(itemsSplit)
            time.style.background = '#08507d';
            time.style.color = 'white';
            document.getElementById('unable_' + val.split('_')[0]).style.display = 'block';
            document.getElementById('disable_' + val.split('_')[0]).style.display = 'none';
          })
        }, 200);
      }
    }
  }

}
